import React from 'react';
import { RenderBlocks } from '@plone/volto/components';

import {
  buildBlocksContentWithoutTitle,
  hasRenderableBlocks,
} from '../helpers';

type ContentBodyProps = {
  content: any;
};

export default function ContentBody({ content }: ContentBodyProps) {
  const isEditing =
    typeof window !== 'undefined' && window.location.pathname.endsWith('/edit');

  const filteredContent = React.useMemo(
    () => (isEditing ? content : buildBlocksContentWithoutTitle(content)),
    [content, isEditing],
  );

  if (filteredContent && hasRenderableBlocks(filteredContent)) {
    return (
      <section
        className="content-view__body content-view__body--blocks"
        aria-label="Conteúdo principal"
      >
        <RenderBlocks content={filteredContent} />
      </section>
    );
  }

  if (content?.body) {
    return (
      <section
        className="content-view__body content-view__body--html"
        aria-label="Conteúdo principal"
        dangerouslySetInnerHTML={{ __html: content.body }}
      />
    );
  }

  return null;
}
